module.exports = __webpack_public_path__ + "img/art_home_background_2.bdee2834.png";